export default __webpack_public_path__ + "static/media/cameraEmoji.51ccf2f4.png";